import React, { useEffect } from 'react';
import CustomTitle from '../../components/UI/title/CustomTitle';
import './style.scss';
import { useDispatch } from 'react-redux';
import { setIsShowPrivacy, setIsShowTerm } from '../../store/termSlice';
import StageContent from './StageContent';
import PageContent from '../../components/PageContent/PageContent';
import useBlockClassName from '../../hooks/useBlockClassName';
import { setIsShowButton } from '../../store/buttonSlice';

export default function Stage({fbcid}) {
    const dispatch = useDispatch();


    const termChange = () => {
        dispatch(setIsShowTerm(true));
    };

    const privacyChange = () => {
        dispatch(setIsShowPrivacy(true));
    };
    const { updateBlockClassName } = useBlockClassName();

    useEffect(() => {
            dispatch(setIsShowButton(false));
        updateBlockClassName('')
    }, [])

    useEffect(() => {
        const url = new URL(window.location);
        if(fbcid) {
            url.searchParams.set('fbcid', fbcid);
            window.history.pushState({}, '', url);
        }
        
    }, []);

    return (
        <div className="page stage page--without-button">
            <PageContent>
                <div className="page-top">
                    <div className="page-content">
                        <CustomTitle
                            style={{ marginBottom: '12rem' }}
                            title="Which of these best<br>describes you?"
                        />
                        <p className="text"  style={{ marginBottom: '24rem' }}>
                        This will help our AI create a growth plan for you based on the stage of your business
                        </p>
                        <div className="stage-wrapper">
                            <StageContent />
                        </div>
                    </div>

                </div>
            </PageContent>

            <div className="stage-bottom">


                By continuing, you accept our<br></br>
                <i onClick={termChange}>Terms of Use</i> and <i onClick={privacyChange}>Privacy Policy</i>
            </div>
        </div>
    );
}
